<app-header *ngIf="_router['url'] != '/errormessage'"  (toggleSideBarForMe)="sideBarToggler()"></app-header>
<mat-drawer-container >
    <mat-drawer  *ngIf="_router['url'] != '/errormessage'" opened="true" position='end' mode="side">
      <app-sidebar></app-sidebar>
    </mat-drawer>
    <mat-drawer-content>
        <div class="hold-transition sidebar-mini layout-fixed">
            <div  class="wrapper">
                <div [ngClass]="{ 'content-wrapper':  _router['url'] != '/errormessage'}" >
                    
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>

<app-footer *ngIf="_router['url'] != '/errormessage'"></app-footer>


